/**
 *
 * DialogTitleWrapper
 *
 */

import { DialogTitle, IconButton, Typography } from '@mui/material';
import * as React from 'react';
import { makeThemeStyle } from '../../../styles/makeThemeStyle';
import { DialogTitleClasses } from '@mui/material/DialogTitle/dialogTitleClasses';
import { ReactNode } from 'react';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeThemeStyle(theme => ({
  dialogTitleRoot: {
    margin: 0,
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(2),
  },
  draggable: {
    cursor: 'move',
  },
  dialogTitle: {
    color: '#025153',
    fontWeight: 700,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(0.5),
  },
}));

interface DialogTitleStyleProps {
  overrideDialogTitleStyle?: string;
  overrideTitleStyle?: string;
  overrideCloseButtonStyle?: string;
  overrideDialogTitleClasses?: Partial<DialogTitleClasses>;
}

interface DialogTitleProps extends DialogTitleStyleProps {
  id: string;
  title: ReactNode;
  onClose: () => void;
}

export const DialogTitleWrapper = (
  props: React.PropsWithChildren<DialogTitleProps>,
) => {
  const styles = useStyles();
  const {
    id,
    overrideDialogTitleStyle,
    overrideTitleStyle,
    overrideCloseButtonStyle,
    overrideDialogTitleClasses,
    onClose,
    title,
    children,
  } = props;
  return (
    <DialogTitle
      className={overrideDialogTitleStyle ?? styles.draggable}
      classes={overrideDialogTitleClasses ?? { root: styles.dialogTitleRoot }}
      id={id}
    >
      <Typography
        variant="h6"
        className={overrideTitleStyle ?? styles.dialogTitle}
        display="block"
        component="span"
      >
        {title}
      </Typography>
      <IconButton
        data-testid="dialogTitleAreaCloseBtn"
        aria-label="Close"
        onClick={onClose}
        className={overrideCloseButtonStyle ?? styles.closeButton}
        size="large"
      >
        <CloseIcon />
      </IconButton>
      {children}
    </DialogTitle>
  );
};
